const STYLES = {
  "Happening Now": "bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-300",
  Upcoming: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  Completed: "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400",
  Delayed: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900/40 dark:text-yellow-300",
  Canceled: "bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-300",
  Available: "bg-secondary/15 text-secondary",
  "In Auction": "bg-secondary/15 text-secondary",
  "Not in Auction": "bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400",
  Sold: "bg-primary text-primary-foreground",
  "Published": "bg-green-100 text-green-800",
  "Final": "bg-primary text-primary-foreground",
  "Reviewed": "bg-blue-100 text-blue-800",
  "Draft": "bg-slate-100 text-slate-600",
  Unofficial: "bg-yellow-100 text-yellow-800",
};

export const StatusBadge = ({ status, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-[11px] font-bold uppercase tracking-wider ${STYLES[status] || "bg-muted text-muted-foreground"}`}
  >
    {status === "Happening Now" && (
      <span className="mr-1.5 h-1.5 w-1.5 rounded-full bg-green-500 animate-pulse" />
    )}
    {status}
  </span>
);
